import { prop } from 'ramda';

import { clear, unprefix } from '../../../../helpers/compact';
import { MEDIA_TYPE } from '../../../../types/press-media';
import { CommonSliceType } from '../../../../types/slice';
import { toRichTextFromProp } from '../../fields/text';
import { toSize } from '../../mapping/size';
import { audio } from '../../partials/audio';
import { quote } from '../../partials/quote';

export const audioSlice = ({ primary }) => {
  const normalizedAudio = audio(primary);

  if (normalizedAudio) {
    return clear({
      type: CommonSliceType.AUDIO_N_CAPTION,
      size: toSize(prop('size', primary)),
      ...normalizedAudio,
    });
  }
};

export const audioWithQuoteSlice = ({ primary }) => {
  const normalizedAudio = audio(primary);
  const normalizedQuote = quote(unprefix('audio', primary));

  if (normalizedAudio && normalizedQuote) {
    const { position, ...normalizedQuoteRest } = normalizedQuote;
    return clear({
      type: CommonSliceType.AUDIO_N_QUOTE,
      media: normalizedAudio,
      mediaType: MEDIA_TYPE.AUDIO,
      quote: normalizedQuoteRest,
      position,
    });
  }
};

export const audioWithTextSlice = ({ primary }) => {
  const normalizedAudio = audio(primary);

  if (normalizedAudio) {
    return clear({
      type: CommonSliceType.AUDIO_N_TXT,
      media: normalizedAudio,
      mediaType: MEDIA_TYPE.AUDIO,
      text: toRichTextFromProp('txt', primary),
    });
  }
};
